import { Component } from '@theme/component';
import { SubscriptionUpdateEvent } from '@theme/events';
import { ThemeEvents } from '@theme/events';

/**
 * @typedef {object} SubscriptionWidgetRefs
 * @property {HTMLFieldSetElement[]} fieldsets – The fieldset elements.
 */

/**
 * A custom element that manages a variant picker.
 *
 * @template {import('@theme/component').Refs} [TRefs=SubscriptionWidgetRefs]
 * @extends Component<TRefs>
 */
export default class SubscriptionWidget extends Component {
  connectedCallback() {
    super.connectedCallback();

    this.addEventListener('change', this.handleSellingPlanChange.bind(this));

    document.addEventListener(ThemeEvents.subscriptionUpdate, this.#subscriptionUpdate.bind(this));
  }

  disconnectedCallback() {
    super.disconnectedCallback();
  }

  /**
   * Handles the subscription change event.
   * @param {Event} event - The subscription change event.
   */
  handleSellingPlanChange(event) {
    if (!(event.target instanceof HTMLElement)) return;
    const subscriptionPlanId = event.target.value;
    const productId = this.dataset.productId;

    document.dispatchEvent(new SubscriptionUpdateEvent(subscriptionPlanId, productId));
  }

  /**
   * Handles seubscription plan update events
   * @param {CustomEvent} event - The sunscription update event
   */
  #subscriptionUpdate(event) {
    const productID = event.detail.productId;
    const subscriptionPlanId = event.detail.subscriptionPlanId;
    if (productID !== this.dataset.productId) return;
    const input = this.querySelector(`input[value="${subscriptionPlanId}"]`);
    // @ts-ignore
    if (input) input.checked = true;
    // this.#updateAddToCardText(subscriptionPlanId);
  }

  #updateAddToCardText(subscriptionPlanId) {
    document.querySelectorAll(`.add-to-cart-text__content`).forEach((element) => {
      const span = element.querySelector('span');
      if (!span) return;
      if (subscriptionPlanId) {
        span.textContent = Theme.translations.start;
      } else {
        span.textContent = Theme.translations.try;
      }
    });
  }
}

if (!customElements.get('subscription-widget')) {
  customElements.define('subscription-widget', SubscriptionWidget);
}
